"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECONDS_TO_RECHECK_TOOLS = exports.MILISECONDS_IN_A_SECOND = exports.TOOLS_TIME_CHECK = exports.TIMEOUT_TOOLS = exports.TIMEOUT_REQUEST = void 0;
exports.TIMEOUT_REQUEST = 2;
exports.TIMEOUT_TOOLS = 10;
exports.TOOLS_TIME_CHECK = 500;
exports.MILISECONDS_IN_A_SECOND = 1000;
exports.SECONDS_TO_RECHECK_TOOLS = 0.5;
//# sourceMappingURL=mobileHandler.constants.js.map